import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export function LegalLayout({ title, children }) {
  return (
    <main className="min-h-screen px-4 pb-20 pt-24 sm:px-6">
      <div className="mx-auto max-w-3xl">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm font-medium text-slate-400 hover:text-white no-underline"
        >
          <ArrowLeft className="h-4 w-4" /> Voltar à página inicial
        </Link>
        <h1 className="mt-6 font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
          {title}
        </h1>
        <div className="prose-pronto mt-8 space-y-6 text-sm leading-relaxed text-slate-300">
          {children}
        </div>
      </div>
    </main>
  );
}

export function Section({ heading, children }) {
  return (
    <section className="glass rounded-2xl p-6">
      <h2 className="font-display text-lg font-semibold text-white">{heading}</h2>
      <div className="mt-3 space-y-3 text-slate-300">{children}</div>
    </section>
  );
}
